Vendd.Scripts.load(function () {

    var promiseHelper = function () {
        
    };
    
    Object.defineProperty(promiseHelper.prototype, "Default", {
        get: function Default() {
            return Q.Promise(function (resolve) { resolve(); });
        }
    });

    promiseHelper.prototype.GetOrDefault = function(task) {

        var self = this;

        if(typeof task !== 'function')
        {
            return self.Default;
        }

        var result = task();  // promisify this

        if(!Q.isPromise(result))
        {
            debugger;
        }

        return Q.isPromise(result)
            ? result
            : Q.Promise(function (resolve) { resolve(result); });

    };

    var Vendd = window.Vendd || {};
    Vendd.Promises = new promiseHelper();

});